module.exports = __webpack_public_path__ + "img/LogoCONTPAQiFirma_Positivo.24e55141.png";